module.exports = __webpack_public_path__ + "public/img/Merencanakan Strategi Pemasangan Iklan di Media Sosial Untuk Menjadi Manajer Periklanan.7f304196.png";